searchModule.factory('searchUrlFactory',
    ['AppSettings', function( AppSettings) {        
        var searchFactory = {};
        
        searchFactory.buildComboSearchUrl = function(parameters) {
            var searchUrl = new URI(AppSettings.startSPANPlusSvcURL + 'productcombos/spandealerid/' + parameters.dealerId + '/');
            searchUrl.addQuery('pagenum', parameters.paging.num);

            if(parameters.paging.size)
                searchUrl.addQuery('pagesize', parameters.paging.size);
            if(parameters.paging.sortBy) {
                searchUrl.addQuery('sortby', parameters.paging.sortBy);
                searchUrl.addQuery('sortdirection', parameters.paging.sortOrder);
            }

            var searchFilters = parameters.filters;
            if (searchFilters && searchFilters.firstName)
                searchUrl.addQuery('fname', searchFilters.firstName);
            if (searchFilters && searchFilters.lastName)
                searchUrl.addQuery('lname', searchFilters.lastName);
            if (searchFilters && searchFilters.contractsOnly)
                searchUrl.addQuery('contractsOnly', searchFilters.contractsOnly);
            if (searchFilters && searchFilters.format)
                searchUrl.addQuery('format', searchFilters.format);
            if (searchFilters && searchFilters.fromDate){
                var dt = searchFilters.fromDate;
                var dtStr = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                searchUrl.addQuery('startdt', dtStr);
            }
            else {
                var now = new Date();
                now.setDate(now.getDate()-15);
                searchUrl.addQuery('startdt', now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }

            if (searchFilters && searchFilters.toDate){
                var dt = searchFilters.toDate;
                var dtStr = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                searchUrl.addQuery('enddt', dtStr);
            }
            else
                searchUrl.addQuery('enddt', '2999-12-31');

            if(searchFilters && searchFilters.vin)
                searchUrl.addQuery('vin', searchFilters.vin);

            if (searchFilters && searchFilters.contractNumber){
                searchUrl.addQuery('contractnumber', searchFilters.contractNumber);
            }

            if (searchFilters && searchFilters.quoteStatuses)
                searchUrl.addQuery('quotestatus', parameters.quoteStatuses);

            if (searchFilters && searchFilters.contractStatus)
                searchUrl.addQuery('contractstatusname', searchFilters.contractStatus);
            
            return searchUrl.toString();
        };

        searchFactory.buildAlternateComboSearchUrl = function(parameters) {
            // if we already have a first name (or don't have a last name to copy) we don't want to do the alternate search. This case is covered by the primary search
            if(!parameters.filters.lastName || parameters.filters.firstName)
                return null;

            var searchUrl = new URI(AppSettings.startSPANPlusSvcURL + 'productcombos/spandealerid/' + parameters.dealerId + '/');
            searchUrl.addQuery('pagenum', parameters.paging.num);

            if(parameters.paging.size)
                searchUrl.addQuery('pagesize', parameters.paging.size);
            if(parameters.paging.sortBy) {
                searchUrl.addQuery('sortby', parameters.paging.sortBy);
                searchUrl.addQuery('sortdirection', parameters.paging.sortOrder);
            }

            var searchFilters = parameters.filters;
            if (searchFilters && searchFilters.lastName)
                searchUrl.addQuery('fname', searchFilters.lastName); // yes, we're sticking last name in the first name field.
                                                                     // if there is no first name value, we do 2 searches, sticking the singular
                                                                     // name in both fields because it's ambiguous if they meant first or last

            if (searchFilters && searchFilters.fromDate)
                searchUrl.addQuery('startdt', searchFilters.fromDate);
            else {
                var now = new Date();
                now.setDate(now.getDate()-15);
                searchUrl.addQuery('startdt', now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }

            if (searchFilters && searchFilters.toDate)
                searchUrl.addQuery('enddt', searchFilters.toDate);
            else
                searchUrl.addQuery('enddt', '2999-12-31');

            if(searchFilters && searchFilters.vin)
                searchUrl.addQuery('vin', searchFilters.vin);

            if (parameters.quoteStatuses)
                searchUrl.addQuery('quotestatus', parameters.quoteStatuses);

            return searchUrl.toString();
        };

        searchFactory.buildMenuSearchUrl = function(parameters) {
            var searchUrl = new URI(AppSettings.startSPANPlusSvcURL + 'menuprointegration/menudealer/' + parameters.dealerId + '/searchDeal');
            if(parameters.filters) {
                if (parameters.filters.firstName)
                    searchUrl.addQuery('customerfirstname', parameters.filters.firstName);

                if(parameters.filters.lastName)
                    searchUrl.addQuery('customerlastname', parameters.filters.lastName);
            }

            if(parameters.stockNumber)
                searchUrl.addQuery('stocknumber', parameters.stockNumber);

            if(parameters.dealNumber)
                searchUrl.addQuery('dealnumber', parameters.dealNumber);

            return searchUrl.toString();
        };

        return searchFactory;
    }
]);
